import React, {useEffect, useRef} from 'react';
import './group-by-dropdown.styles.scss';

// Map of internal group-by values to their user-facing display labels.
// Add an entry here whenever an internal value needs a different label
// (e.g. camelCase state value that should render as "Task Type").
const DISPLAY_LABELS = {
    taskType: 'Task Type',
};

const getDisplayLabel = (value) => {
    if (!value) return '';
    return DISPLAY_LABELS[value] ?? value;
};

// Menu items per page. Each entry is an exact match against the `groupBy`
// state value, so no case-insensitive / substring comparisons are needed.
const PROJECT_MENU_ITEMS = [
    { value: 'Status', label: 'Status' },
    { value: 'Priority', label: 'Priority' },
    { value: 'None', label: 'None' },
];

const TASK_MENU_ITEMS = [
    { value: 'Category', label: 'Category' },
    { value: 'Priority', label: 'Priority' },
    { value: 'Permission', label: 'Permission' },
    { value: 'taskType', label: 'Task Type' },
    { value: 'Action', label: 'Action' },
    { value: 'None', label: 'None' },
];

const getMenuItems = (pageIdentifier) =>
    pageIdentifier === 'task' ? TASK_MENU_ITEMS : PROJECT_MENU_ITEMS;

const GroupByDropdown = ({groupByFunction, groupBy, show, setShow, pageIdentifier}) => {
    const dropdownRef = useRef();
    const dropdownControl = (e) => {
        if (dropdownRef.current.contains(e.target))  {
            setShow(true);
            return;
        }
        setShow(false);
    }

    const handleSelect = (groupByName) => {
        groupByFunction(groupByName);
    }

    useEffect(() => {
        document.addEventListener("mousedown", dropdownControl);
        return () => {
            document.removeEventListener("mousedown", dropdownControl);
        };
    }, [])

    const menuItems = getMenuItems(pageIdentifier);

    return (

        <div ref={dropdownRef} >
            <div className={`group-by-button ${groupBy === 'None' ? 'group-inactive' : 'group-active' } ${show? 'show' : ''}`}>
                <p className = {`${groupBy === 'None' ? 'group-inactive' : 'group-active' }`}>Group by: <span>{getDisplayLabel(groupBy)}</span></p>
            </div>

            {
                show &&
                <>
                    <div className='dropdown-tip'></div>
                    <div className='group-by-menu-container'>
                        <div className='group-by-menu-item header'>Group by:</div>

                        <hr className='group-by-menu-separator'></hr>

                        {menuItems.map(({value, label}) => {
                            const isSelected = groupBy === value;
                            return (
                                <div
                                    key={value}
                                    className={`group-by-menu-item ${isSelected ? 'selected' : 'hover-grey'}`}
                                    onClick={() => handleSelect(value)}
                                >
                                    <input type={'radio'} checked={isSelected} readOnly /> {label} <p></p>
                                </div>
                            );
                        })}

                    </div>
                </>
            }
        </div>
    )
}

export default GroupByDropdown;
